export default __webpack_public_path__ + "static/media/awareness.85434c79.svg";